import { Pane, ConfigureButtons } from "components/materials";
import { majorScale, minorScale } from "helpers/utilities";
import { BlankSlate } from "./BlankSlate";
import { CardHeading } from "./CardHeading";
import { CardLinkButton } from "./CardLinkButton";

export const DRAW_PROCESSING_TIME_CONFIGURATION_SETTINGS = {
  i: "drawProcessingTime",
  x: 0,
  y: 4,
  w: 2,
  h: 1.25,
  disabled: false,
};

export function DrawProcessingTime({
  cards,
  isConfigurable,
  isDisabled,
  name,
  projects,
  setCards,
}) {
  const showBlankSlate = projects.length === 0;

  return (
    <Pane height="100%" width="100%" padding={majorScale(2)}>
      <Pane
        display="flex"
        marginBottom={minorScale(3)}
        justifyContent="space-between"
        paddingBottom={majorScale(2)}
      >
        <CardHeading disabled={isDisabled} text="Draw Processing Time" />
        {isConfigurable && (
          <ConfigureButtons
            isDisabled={isDisabled}
            cards={cards}
            setCards={setCards}
            name={name}
          />
        )}
        {!isConfigurable && <CardLinkButton href="/" />}
      </Pane>
      {showBlankSlate && <BlankSlate />}
    </Pane>
  );
}
